import { Record, List } from 'immutable';
import { actionTypes, pagingActions, fetchListActions, registerParticipantActions } from './unregistered-participants.actions';
import * as api from '../../api';
import { authActions } from '../../auth';
import { pagingDataUtilities } from '../../common';
import  moment from 'moment';

// default to all participants updated in the past year
const lastYear = moment().subtract(365, 'days').startOf('day').format();

export const UnregisteredParticipantState = Record({
  pagingData: pagingDataUtilities.PagingState({
    sortBy : 'lname',
    itemsPerPage : 50
  }),
  searchInput: '',
  searchQuery: '',
  auditDateRestricted: lastYear,
  showConfirmModal: false,
  listState: api.ApiCallState({}),
  participantsToRegister: List([]),
  registrationState: api.ApiCallState({}),
  radioButtonValue: 'true'
});

export const unregisteredParticipantsReducer = (initialState = new UnregisteredParticipantState(), action) => {

  var state = initialState.set('pagingData',
    pagingDataUtilities.pagingReducer(initialState.get('pagingData'), action, pagingActions));

  const invalidateListActions = pagingActions.allTypes.concat([
    authActions.actionTypes.CREATE_ETO_SESSION_SUCCESS,
    actionTypes.START_SEARCH,
    actionTypes.CLEAR_PARTICIPANTS_TO_REGISTER]);
  state = state.set('listState',
      api.apiCallReducer(state.get('listState'), action, fetchListActions, invalidateListActions))
    .set('registrationState',
      api.apiCallReducer(state.get('registrationState'), action, registerParticipantActions));

  switch (action.type) {
    case "@@router/LOCATION_CHANGE":
      if(action.pathname !== "registration"){ // invalidate the registration results if not on the registration summary page
        return state.set('registrationState', api.ApiCallState({isValid: false}));
      }
      return state;
    case actionTypes.CLEAR_PARTICIPANTS_TO_REGISTER: {
      const section = 'participantsToRegister';
      return state.set(section, List([]));
    }
    case actionTypes.SELECT_PARTICIPANT: {
      const section = 'participantsToRegister';
      const selectedParticipants = state.get(section);
      var index = selectedParticipants.findIndex(participantId => participantId === action.id);
      if(index === -1) {
        return state.set(section, selectedParticipants.push(action.id));
      }
      else {
        return state.set(section, selectedParticipants.delete(index));
      }
    }
    case actionTypes.SELECT_ALL_PARTICIPANTS: {
      const participantsToRegister = state.get('participantsToRegister');
      const listState = state.get('listState');
      const { data } = listState || {};

      if(data && data.results) {
        var modifiedState = state;

        modifiedState = modifiedState.set('participantsToRegister', participantsToRegister.filter(id => !data.results.some(val => val.demographics.externalId === id)));
        if(!data.results.every(val => participantsToRegister.some(id => id === val.demographics.externalId))) {
          data.results.forEach(participant => {
            var section = 'participantsToRegister';
            modifiedState = modifiedState.set(section, modifiedState.get(section).push(participant.demographics.externalId));
          });
        }
        return modifiedState;
      }
      else {
        return state;
      }
    }
    case actionTypes.SET_SEARCH_TEXT:
      return state.set('searchInput', action.text);
    case actionTypes.START_SEARCH:
      return state.set('searchQuery', state.get('searchInput')).setIn(['pagingData', 'currentPage'], 1);
    case actionTypes.RESTRICT_AUDIT_DATE:
      return state.set('auditDateRestricted', action.auditDate)
                  .setIn(['listState', 'isValid'], false);
    case actionTypes.UNRESTRICT_AUDIT_DATE:
      return state.set('auditDateRestricted', null)
                  .setIn(['listState', 'isValid'], false);
    case actionTypes.CLOSE_CONFIRM_MODAL:
      return state.set('showConfirmModal', false);
    case actionTypes.SHOW_CONFIRM_MODAL:
      return state.set('showConfirmModal', true);
    case actionTypes.SET_SELECTED_SAVE_OPTION:
      return state.set('radioButtonValue', action.value);
    default:
      return state
  }
}
